module.exports = __webpack_public_path__ + "static/media/pbclsg2.f34204af.png";